import type { RequestMetrics } from '../../core/types';
import { readResponseServer } from './responseServer';

export function buildRequestMetrics(kind: RequestMetrics['requestKind'], data: any, error = false): RequestMetrics {
  const stats = data?.part?.stats ?? data?.stats ?? data?.frag?.stats;
  const loading = stats?.loading;
  const difference = (end: unknown, start: unknown): number | undefined =>
    typeof end === 'number' && typeof start === 'number' && Number.isFinite(end) &&
    Number.isFinite(start) && end > 0 && start >= 0 && end >= start ? end - start : undefined;
  const server = readResponseServer(data?.networkDetails);
  const code = data?.response?.code ?? data?.networkDetails?.status;
  return {
    requestKind: kind,
    result: error ? /timeout/i.test(data?.details ?? '') ? 'timeout' : 'error' : 'success',
    statusCode: typeof code === 'number' && code > 0 ? code : undefined,
    ttfbMs: difference(loading?.first, loading?.start),
    downloadMs: difference(loading?.end, loading?.first),
    bytes: typeof stats?.loaded === 'number' && Number.isFinite(stats.loaded) ? Math.max(0, stats.loaded) : undefined,
    retryCount: typeof stats?.retry === 'number' && Number.isFinite(stats.retry) ? Math.max(0, stats.retry) : undefined,
    serverName: server.name ?? undefined,
    server: server.ip ?? undefined,
    details: error ? data?.details : undefined,
  };
}

export function requestKindForError(details: string): RequestMetrics['requestKind'] | null {
  if (!/load(error|timeout)/i.test(details)) return null;
  if (/manifest/i.test(details)) return 'manifest';
  if (/level|audiotrack|subtitletrack/i.test(details)) return 'playlist';
  if (/frag/i.test(details)) return 'fragment';
  if (/key/i.test(details)) return 'key';
  return 'other';
}
